const KEY = "gas.signInNotice";

/** Remember why the user was signed out, so the sign-in screen can say so once. */
export function setSignInNotice(message: string): void {
  try {
    window.sessionStorage.setItem(KEY, message);
  } catch {
    // storage unavailable (private window, blocked site data): the notice is a courtesy only
  }
}

/** Returns the pending notice and clears it. */
export function takeSignInNotice(): string | null {
  try {
    const message = window.sessionStorage.getItem(KEY);
    if (message !== null) {
      window.sessionStorage.removeItem(KEY);
    }
    return message;
  } catch {
    return null;
  }
}
